import React, { MouseEventHandler, useEffect, useState } from "react";
import Badge from "../../../components/Badge";
import Button from "../../../components/Button";
import Loader from "../../../components/Loader";
import H4 from "../../../components/Typography/H4";
import { useFetchApi } from "../../../hooks/useFetchApi";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import routes from "../../../setup/routes";
import TextFieldWithLabel from "../../../components/TextFieldWithLabel";

const RolePermissions: React.FC = (): React.ReactElement => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [role, setRole] = useState<any>({});
  const [updatedPermissions, setUpdatedPermission] = useState<Array<any>>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const {
    execute: getPermissions,
    loading,
    response: permissions,
  } = useFetchApi("/api/permissions", {}, "GET");

  const {
    execute: getRoleById,
    loading: roleDetailsLoading,
    response: roleDetails,
  } = useFetchApi(`/api/roles/${id}`, {}, "GET");

  const {
    execute: getRolePermission,
    loading: rolePermissionLoading,
    response: rolePermissions,
  } = useFetchApi(`/api/roles/${id}/permissions`, {}, "GET");

  const handleOnSuccess = () => {
    // getPermissions();
    // getRolePermission();
    navigate(`${routes.DASHBOARD}/${routes.USER_MANAGEMENT}/${routes.ROLES}`);
  };

  const { execute: updateRolePermission } = useFetchApi(
    `/api/roles/${id}/permissions`,
    {},
    "PUT",
    handleOnSuccess
  );

  useEffect(() => {
    getPermissions();
    getRolePermission();
    getRoleById();
  }, []);

  useEffect(() => {
    if (
      permissions &&
      rolePermissions &&
      Object.keys(rolePermissions) &&
      !loading &&
      !rolePermissionLoading
    ) {
      const updatedPerm = permissions.map((permission: any) => {
        return {
          key: permission.action_keys,
          entitlement_id: permission.id,
          checked: Object.keys(rolePermissions).includes(
            permission.id.toString()
          )
            ? true
            : false,
          role_per_id: rolePermissions[permission.id.toString()],
        };
      });
      setUpdatedPermission(updatedPerm);
    }
  }, [permissions, loading, rolePermissionLoading, rolePermissions]);

  useEffect(() => {
    if (roleDetails && !roleDetailsLoading) {
      setRole(roleDetails);

      // TODO: set the select all to unselect all based on the loop data
    }
  }, [roleDetails, roleDetailsLoading]);

  const handleChange = (e: any) => {
    const id = e.target.id;
    const updateKey = e.target.value;
    if (["role_name", "role_status"].includes(id)) {
      setRole({
        ...role,
        [id.split("_")[1]]: updateKey,
      });
    } else {
      setUpdatedPermission(
        updatedPermissions.map((permission: any) => {
          if (permission.key === updateKey) {
            return {
              ...permission,
              checked: !permission.checked,
            };
          }
          return permission;
        })
      );
    }
  };

  const handleUpdate = () => {
    console.log("u", updatedPermissions);
    updateRolePermission({
      role_permissions: updatedPermissions,
      role,
    });
  };

  const handleSelectAll = () => {
    setUpdatedPermission(
      updatedPermissions.map((permission: any) => {
        return {
          ...permission,
          checked: !selectAll,
        };
      })
    );
    setSelectAll(!selectAll);
  };

  return (
    <div className="flex flex-col w-full p-8 bg-white">
      <Loader show={loading} />
      <div className="flex justify-between mb-8 text-white">
        <H4>Role Permissions</H4>
        <Button id="newEdit" onClick={handleUpdate} variant="primary">
          Update Role & Permissions
        </Button>
      </div>
      <div className="flex w-full justify-end items-center">
        <Button onClick={handleSelectAll}>
          {!selectAll ? "Select All" : "Unselect All"}
        </Button>
      </div>
      <div className="flex flex-col border-2 border-gray-100 rounded-lg p-4 w-6/12 items-start">
        {role ? (
          <>
            <TextFieldWithLabel
              id="role_name"
              label="Role"
              value={role.name}
              onChange={handleChange}
            />
            <div className="flex gap-4">
              <label htmlFor="role_status">Status</label>
              <input
                id="role_status"
                type="checkbox"
                checked={role.status}
                value={role.status}
                onChange={() => {
                  setRole({
                    ...role,
                    status: !role.status,
                  });
                }}
              />
            </div>
          </>
        ) : null}
      </div>
      <div className="flex mt-4">
        <table className="w-full">
          <thead>
            <tr>
              <td className="p-2 font-bold border-b">Key</td>
              <td className="p-2 font-bold border-b">Status</td>
            </tr>
          </thead>
          {updatedPermissions && updatedPermissions.length ? (
            <tbody>
              {updatedPermissions.map((permission: any) => (
                <tr
                  className="border-b hover:shadow-lg hover:border-none cursor-pointer"
                  key={permission.key}
                >
                  <td className="p-2">{permission.key}</td>
                  <td className="p-2">
                    <input
                      className="w-5 h-5"
                      type="checkbox"
                      value={permission.key}
                      checked={permission.checked}
                      onClick={handleChange}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          ) : null}
        </table>
      </div>
    </div>
  );
};

export default RolePermissions;
